/**
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-19-v1
 */
import { NavLink } from 'react-router-dom';
import { ROUTES, SECTION_LABELS, SECTION_ORDER } from '../../lib/routes';

export function Sidebar() {
    return (
        <aside className="admin-sidebar">
            <NavLink to="/" className="sidebar-brand">
                <div className="sidebar-brand-logo">PD</div>
                <div className="sidebar-brand-text">
                    <span className="sidebar-brand-title">Producer Dashboard</span>
                    <span className="sidebar-brand-kicker">Admin</span>
                </div>
            </NavLink>

            {SECTION_ORDER.map((section) => {
                const items = ROUTES.filter((r) => r.section === section);
                if (items.length === 0) return null;
                return (
                    <div key={section} className="sidebar-section">
                        <div className="sidebar-section-label">{SECTION_LABELS[section]}</div>
                        {items.map((r) => (
                            <NavLink
                                key={r.path}
                                to={r.path}
                                end={r.path === '/'}
                                className="sidebar-link"
                            >
                                <r.icon />
                                <span>{r.label}</span>
                            </NavLink>
                        ))}
                    </div>
                );
            })}
        </aside>
    );
}
